import { getBuyerLastNameFromSurveyData } from '.';
import { CheckoutState } from '../../state';
import { getLastNameToPrefill } from '../../utils/user';

export const getLastNameToPrefillFirstAttendeeInfo = (state: CheckoutState) =>
    getBuyerLastNameFromSurveyData(state) || getLastNameToPrefill(state);
